const l = {
  lng: "ru",
  style: "currency",
  currency: "RUB",
  maximumFractionDigits: 0
};
function u(t, o) {
  const n = {
    ...l,
    ...o
  }, { lng: e, hasCurrency: c, ...i } = n;
  return c ? new Intl.NumberFormat(e, i).format(t) : new Intl.NumberFormat(e, {
    ...n,
    currencyDisplay: "code"
  }).formatToParts(t).filter((r) => r.type !== "currency").filter((r) => r.type !== "literal" || r.value.trim().length !== 0).map((r) => r.value).join("");
}
export {
  u as formatCurrency
};
